<template>
    <!--<a href="/instructor" id="instructorProfile">-->
    <router-link :to="{name:'instructor', params:{id:id}}" id="instructorProfile" target="_blank">
      <div class="instructorAvatar" v-if="avatar" v-bind:style="{ backgroundImage: 'url(' + avatar + ')' }"></div>
      <div class="instructorAvatar" v-else v-bind:style="{ backgroundImage: 'url(' + no_avatar + ')' }"></div>
      <div class="instructorInfo">
        <p class="note">
          <span v-if="title&&title.length<=60">{{title}}</span>
          <span v-if="title&&title.length>60">{{title.slice(0,60)+'...'}}</span>
          <span v-if="title&&provider"> at </span>
          <span v-if="provider">{{provider}}</span>
        </p>
        <h4>{{name}}</h4>
        <p class="note" v-if="course_number>0">{{course_number}} <span v-if="course_number>1">courses</span><span v-else>course</span></p>
      </div>
    </router-link>
  <!--</a>-->
</template>

<script>
export default {
  name: 'InstructorProfile',
  props: {
    id: Number,
    title: String,
    provider: String,
    name: String,
    course_number: Number,
    avatar: String
  },
  data(){
    return{
      no_avatar: require('../../assets/img/empty/instructor.svg')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/General/InstructorProfile.vue